import { observer } from 'mobx-react'
import { title } from 'process'
import { Fragment, ReactElement, useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import ContentState from '../../../../../stores/ContentState'
import GlobalState from '../../../../../stores/GlobalState'
import Option from '../../../../common/Select/Option'
import Select from '../../../../common/Select/Select'

type TabProps = {
  title: string
  children: any
  link: string
}

type TabTitleProps = {
  title: string
  link: string
  index: number
  setSelectedTab: (index: number) => void
  selectedTab: number
}

type TabsProps = {
  children: ReactElement[]
  selectedTabOuter?: string
  getTab: (value: number) => void
}

export const TabTitle: React.FC<TabTitleProps> = observer(
  ({ title, link, setSelectedTab, index, selectedTab }) => {
    const navigate = useNavigate()

    const onClick = useCallback(() => {
      // setSelectedTab(index)
      // navigate(link)
    }, [setSelectedTab, index])

    return (
      <>
        <li
          className={selectedTab === index ? 'tab active' : 'tab'}
          onClick={() => {
            let lang = GlobalState.currentLocale.lang.includes('En')
              ? '/en'
              : GlobalState.currentLocale.lang.includes('ру')
              ? '/ru'
              : ''
            navigate(`${lang}/${link}`)
            setSelectedTab(index)
          }}
        >
          {title}
        </li>
      </>
    )
  },
)

export const Tab: React.FC<TabProps> = observer(({ children }) => {
  return <div>{children}</div>
})

export const Tabs: React.FC<TabsProps> = observer(({ children, getTab }) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const { param } = useParams()
  const onSelectHandler = (selectedOption: string) => {
    const _selectedTabId = children.findIndex(
      (child) => child.props?.title === selectedOption,
    )
    if (_selectedTabId !== -1) {
      setSelectedTab(_selectedTabId)
    }
  }

  useEffect(() => {
    if (param) {
      children.forEach((c, i) => {
        if (c.props.link.includes(param)) {
          setSelectedTab(i)
        }
      })
    }
  }, [param, ContentState.documents])

  useEffect(() => {
    getTab(selectedTab)
  }, [selectedTab])

  return (
    <>
      <Select
        defaultValue={children[selectedTab].props.title}
        onSelect={onSelectHandler}
      >
        {children.map((item, i) => {
          if (item.props.title == children[selectedTab].props.title) {
            return <></>
          }

          return (
            <Option value={item.props.title} key={i} link={item.props.link}>
              {item.props.title}
            </Option>
          )
        })}
      </Select>
      <ul className="tabs-list">
        {children.map((item, index) => (
          <TabTitle
            key={index}
            link={item.props.link}
            title={item.props.title}
            index={index}
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
          />
        ))}
      </ul>
      <div className="tabs">
        {/* <ul className="tabs-list">
          {children.map((item, index) => (
            <TabTitle
              key={index}
              link={item.props.link}
              title={item.props.title}
              index={index}
              setSelectedTab={setSelectedTab}
              selectedTab={selectedTab}
            />
          ))}
        </ul> */}
        <div className="tab-content">{children[selectedTab]}</div>
      </div>
    </>
  )
})
